export * from './video-control.component';